import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const SID_KEY = "acs_visitor_sid";
const HEARTBEAT_MS = 20000;

function sessionId() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) || `s-${Date.now()}-${Math.random()}`;
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

function basePayload() {
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
    if (params.get(k)) utm[k.replace("utm_", "")] = params.get(k);
  });
  return {
    sid: sessionId(),
    referrer: document.referrer || "",
    screen: `${window.screen.width}x${window.screen.height}`,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    language: navigator.language || "",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    utm,
  };
}

export function trackEvent(event) {
  api
    .post("/track", { ...basePayload(), path: window.location.pathname, title: document.title, event })
    .catch(() => {});
}

/** Invisible presence heartbeat. Renders nothing anywhere on the site. */
export function VisitorTracker() {
  const { pathname } = useLocation();
  const path = useRef(pathname);
  path.current = pathname;

  useEffect(() => {
    const beat = () => {
      if (document.visibilityState === "hidden") return;
      api
        .post("/track", { ...basePayload(), path: path.current, title: document.title })
        .catch(() => {});
    };
    beat();
    const timer = setInterval(beat, HEARTBEAT_MS);
    document.addEventListener("visibilitychange", beat);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", beat);
    };
  }, [pathname]);

  return null;
}
